export type WordTableColumnAlignment = 'left' | 'center' | 'right' | null

export const getWordTableAlignment = <T>(
  columnAlignment: WordTableColumnAlignment | undefined,
  direction: 'ltr' | 'rtl',
  alignmentTypes: { LEFT: T; CENTER: T; RIGHT: T },
): T => {
  // GFM 列对齐使用物理方向，不随 RTL 文字方向翻转。
  switch (columnAlignment) {
    case 'left':
      return alignmentTypes.LEFT
    case 'center':
      return alignmentTypes.CENTER
    case 'right':
      return alignmentTypes.RIGHT
    default:
      return direction === 'rtl' ? alignmentTypes.RIGHT : alignmentTypes.LEFT
  }
}
